import { useQuery } from "@tanstack/react-query";
import { CalculatorKeys } from "web_myplann/Api/Calculators/CalculatorKeys";
import {
	getCalculatorMortgageRatesV2,
	type MortgageRateResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useMortgageRatesQuery = () => {
	return useQuery({
		queryKey: CalculatorKeys.mortgageRates(),
		queryFn: processResponse(() => getCalculatorMortgageRatesV2(), {
			skipToastFor: true,
		}),
		select: (response: { data: MortgageRateResponseDTO[] }) => response.data,
	});
};
